<div class="page-preloader">
  <div class="page-preloader__spinner">
    <span></span>
    <span></span>
    <span></span>
  </div>
</div>
